import React, { useState } from 'react';
import NavigationPopup from './NavigationPopup';
import styles from './NavigationWithPopups.module.css';
import ConstituencyWise from "./ConstituencyWise";
import RegionWiseResults from "./RegionWiseResults";

const NavigationWithPopups = () => {
  const [activePopup, setActivePopup] = useState(null);

  const navItems = [
    {
      id: 'constituency',
      label: 'Constituency Wise'
    },
    {
      id: 'region',
      label: 'Region Wise'
    },
    {
      id: 'voteshare',
      label: 'Vote Share',
      url: 'https://results.mathrubhumi.com/result/voteshare/bihar.html'
    },
    {
      id: 'map',
      label: 'Map View',
      url: 'https://results.mathrubhumi.com/result/mapview/bihar.html'
    },
    {
      id: 'live_blog',
      label: 'Live Blog',
      isLink: true,
      url: 'https://english.mathrubhumi.com/news/india/bihar-assembly-election-results-2025-counting-live-updates-hyfe0m83',
      target: '_blank',
      rel: 'noopener noreferrer'
    }
  ];

  const openPopup = (item) => {
    const windowedItems = ['constituency', 'region', 'voteshare', 'map'];
    if (windowedItems.includes(item.id)) {
      const width = 1000;
      const height = 800;
      const leftPosition = (window.screen.width - width) / 2;
      const topPosition = (window.screen.height - height) / 4;

      // Set the URL based on the item type
      let url;
      if (item.url) {
        url = item.url;
      } else if (item.id === 'constituency' || item.id === 'region') {
        // For local components, use the current URL with a query parameter
        url = `${window.location.origin}${window.location.pathname}?show=${item.id}`;
      } else if (item.id === 'live_blog') {
        url = 'https://www.mathrubhumi.com/election/kerala-local-body-2025/idukki/aam-aadmi-party-karinkunnam-bypoll-win-q9y2zy3u';
      }
      window.open(
        url, // Use the constructed URL, not item.url
        `${item.id}View`,
        `width=${width},height=${height},top=${topPosition},left=${leftPosition},resizable=yes,scrollbars=yes`
      );
    } else {
      // Handle other popups as before
      setActivePopup(item.id);
    }
  };

  const closePopup = () => {
    setActivePopup(null);
  };

  const renderPopupContent = () => {
    const popupContents = {
      constituency: <ConstituencyWise />,
      region: <RegionWiseResults />,
      voteshare: <p>Vote share statistics will be displayed here.</p>,
      map: <p>Interactive map will be displayed here.</p>,
      live_blog: <p>Live blog content will be displayed here.</p>
    };

    if (!activePopup) return null;

    return (
      <NavigationPopup
        /*title={activePopup.split('_').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ')}*/
        onClose={closePopup}
        height="800px"
        width="800px"
        maxWidth="1000px"
      >
        {popupContents[activePopup]}
      </NavigationPopup>
    );
  };

  return (
    <>
      <div className={styles.navigationLinks}>
        {navItems.map((item) => (
          item.isLink ? (
            <a
              key={item.id}
              href={item.url}
              target={item.target}
              rel={item.rel}
              className={styles.navLink}
            >
              {item.label}
              <img src={`${process.env.PUBLIC_URL}/assets/d-arrow.png`} alt='' />
            </a>
          ) : (
            <button
              key={item.id}
              className={styles.navLink}
              onClick={() => openPopup(item)}
            >
              {item.label}
              <img src={`${process.env.PUBLIC_URL}/assets/d-arrow.png`} alt='' />
            </button>
          )
        ))}
      </div>
      {renderPopupContent()}
    </>
  );
};

export default NavigationWithPopups;